export default defineNuxtRouteMiddleware(async (to, from) => {
	const user = await getCurrentUser()
	// const router = useRouter()
	// const route = useRoute()
	// console.log(user.email)
	const LangsStore = useLangsStore()
	const UserStore = useUserStore()

	// redirect the user to the login page
	if (!user) {
		if (to.path !== "/" + LangsStore.context.lang_id + "/login") {
			// if (typeof route.query.redirect === "string") {
			// 	return router.push(route.query.redirect)
			// }
			// return navigateTo({
			// 	path: "/" + LangsStore.context.lang_id + "/login",
			// 	query: {
			// 		redirect: to.fullPath,
			// 	},
			// })
		} else {
			console.log("auth middleware run")
		}
	}

	// Initialize user roles if not already done
	if (!UserStore.user_full?.auth) {
		if (user) await UserStore.initUserRoles(user)
	}

	// Role-based access control for pages
	const roles = UserStore.user_full?.roles || {}
	const routeRoleMap = Array.isArray(UserStore.user_route_role_map) ? UserStore.user_route_role_map : []

	for (const { prefix, role, requestAccess } of routeRoleMap) {
		if (
			to.path.includes(prefix) &&
			!(roles[role] === "editor" || roles[role] === "reader") &&
			!to.path.includes(requestAccess)
		) {
			if (role === "app") {
				return navigateTo("/")
			} else if (!to.path.includes(requestAccess)) {
				return navigateTo("/" + LangsStore.context.lang_id + requestAccess)
			}
		}
	}
})
